import rill from "rill";
import redirect from "@rill/redirect";
import List from "./list";
import Edit from "./edit";
import View from "./view";

const Custom = (app) => {
  app
    .get("/custom", redirect("/dashboard/metrics/custom/list"))
    .at("/custom/*", rill().setup(List).setup(Edit).setup(View));
};

export default Custom;
